module.exports = __webpack_public_path__ + "static/media/sintegra-mini-logo.f00777ee.jpg";